import { render, staticRenderFns } from "./AllowDeny.vue?vue&type=template&id=61babe80&scoped=true&"
import script from "./AllowDeny.vue?vue&type=script&lang=js&"
export * from "./AllowDeny.vue?vue&type=script&lang=js&"
import style0 from "./AllowDeny.vue?vue&type=style&index=0&id=61babe80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61babe80",
  null
  
)

export default component.exports